import { render } from "./DTEncuestasDisp.vue?vue&type=template&id=5ca6a6fc"
import script from "./DTEncuestasDisp.vue?vue&type=script&lang=js"
export * from "./DTEncuestasDisp.vue?vue&type=script&lang=js"

import "./DTEncuestasDisp.vue?vue&type=style&index=0&id=5ca6a6fc&lang=css"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__